import React, { Component } from 'react';
import './AdFooter.css';

class AdFooter extends Component {
    handleToggleCollapse = () => {
        if (this.props.onToggleCollapse) {
            this.props.onToggleCollapse();
        }
    };

    render() {
        const { isCollapsed = false } = this.props;

        return (
            <aside
                className={`ad-footer ${isCollapsed ? 'collapsed' : ''}`}
                aria-label="Advertisement"
            >
                <div className="ad-footer-header">
                    <div className="ad-footer-title">
                        <span className="ad-label">Advertisement</span>
                        <div className="ad-footer-controls">
                            <button
                                type="button"
                                className="footer-control-btn collapse-btn"
                                onClick={this.handleToggleCollapse}
                                title={isCollapsed ? "Expand ads" : "Collapse ads"}
                                aria-label={isCollapsed ? "Expand advertisements" : "Collapse advertisements"}
                                aria-expanded={!isCollapsed}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    {isCollapsed ? (
                                        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"/>
                                    ) : (
                                        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/>
                                    )}
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                
                {!isCollapsed && <div className="ad-footer-content">
                    <div className="ad-container">
                        {/* Sample Ad 1 - Banner */}
                        <div className="ad-banner ad-banner-primary">
                            <div className="ad-banner-content">
                                <div className="ad-banner-text">
                                    <h4>Premium Experience Awaits</h4>
                                    <p>Upgrade to Premium for ad-free viewing and exclusive content</p>
                                </div>
                                <button type="button" className="ad-cta-btn">
                                    Upgrade Now
                                </button>
                            </div>
                        </div>

                        {/* Sample Ad 2 - Product Ad */}
                        <div className="ad-banner ad-banner-secondary">
                            <div className="ad-banner-content">
                                <div className="ad-product-image">
                                    <div className="ad-placeholder">
                                        <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className="ad-banner-text">
                                    <h5>Special Offer</h5>
                                    <p>Get 50% off your first month of premium features</p>
                                </div>
                                <button type="button" className="ad-cta-btn ad-cta-secondary">
                                    Learn More
                                </button>
                            </div>
                        </div>

                        {/* Sample Ad 3 - Small Banner */}
                        <div className="ad-banner ad-banner-compact">
                            <div className="ad-banner-content">
                                <div className="ad-banner-text">
                                    <span className="ad-compact-text">
                                        <strong>New Features:</strong> Enhanced video quality and faster streaming
                                    </span>
                                </div>
                                <button type="button" className="ad-cta-btn ad-cta-compact">
                                    Try Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>}
            </aside>
        );
    }
}

export default AdFooter; 